exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".channel-template[data-v-260edeb2]{min-height:100px;margin-top:-35px}", ""]);

